var _style, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvatarIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 155 155",
    style: {
      enableBackground: "new 0 0 155 155"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#2A6DFF;}\n\t.st1{clip-path:url(#SVGID_00000085971342968034959850000007322084347937248666_);fill:#2A6DFF;}\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M155,77.5c0,42.8-34.7,77.5-77.5,77.5S0,120.3,0,77.5S34.7,0,77.5,0S155,34.7,155,77.5z M77.5,13.4 c-35.4,0-64.1,28.7-64.1,64.1s28.7,64.1,64.1,64.1s64.1-28.7,64.1-64.1S112.9,13.4,77.5,13.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.5,63.2c0,13.8-12,26.1-27,26.1c-15.1-0.5-27-12.4-27-26.1s12-25.8,27-26.1 C117.5,37.5,129.5,49.5,129.5,63.2z M118.9,63.2c0-8.8-7.3-15.9-16.3-15.9c-9,0-16.3,7.1-16.3,15.9s7.3,15.9,16.3,15.9 C111.5,79.2,118.9,72,118.9,63.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.5,111.8c0,7.4-6.3,13.4-14.4,13.6c-8.1,0-14.4-6.2-14.4-13.6c0-7.4,6.4-13.7,14.4-13.7 C90.1,98.3,96.5,104.4,96.5,111.8z M87.6,111.8c0-3-2.5-5.4-5.5-5.4c-3.1,0-5.5,2.4-5.5,5.4s2.5,5.4,5.5,5.4 C85.1,117.2,87.6,114.8,87.6,111.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,55.2c-3.3,0-6.2,2.7-6.2,5.9s2.8,5.8,6.2,5.8c3.6,0,6.2-2.6,6.2-5.8S64.4,55.2,61,55.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.2,97.3c-3.3,0-6.2,2.7-6.2,5.9c0,3.2,2.8,5.8,6.2,5.8c3.6,0,6.2-2.6,6.2-5.8 C46.4,99.9,43.6,97.3,40.2,97.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M115.4,105c-3.3,0-6.2,2.7-6.2,5.9c0,3.2,2.8,5.8,6.2,5.8c3.6,0,6.2-2.6,6.2-5.8 C121.6,107.6,118.8,105,115.4,105z"
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_1_",
    cx: 77.5,
    cy: 77.5,
    r: 64.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139981598031419552660000005614759172815122077_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000139981598031419552660000005614759172815122077_)",
      fill: "#2A6DFF"
    },
    d: "M55.2,36 c-0.4,7.3-7.1,13-15.2,12.7c-8-0.5-14-7.1-13.6-14.5c0.4-7.3,7.3-13.2,15.2-12.8C49.6,22.2,55.6,28.6,55.2,36z M46.3,35.4 c0.2-3-2.1-5.5-5.2-5.7c-3.1-0.2-5.7,2.1-5.9,5.1c-0.2,3,2.1,5.5,5.2,5.7C43.5,40.7,46.1,38.4,46.3,35.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarIconBlue);
export default __webpack_public_path__ + "static/media/avatar_icon_blue.4e5b440a8bdeac63d417bb59d60a8247.svg";
export { ForwardRef as ReactComponent };